import React from 'react';

function EmptyState({ title = 'Nothing here yet', description, action = null }) {
  return (
    <div className="text-center text-muted py-4 px-3">
      <div className="fw-semibold text-body mb-1">{title}</div>
      {description ? <p className="mb-2 small">{description}</p> : null}
      {action}
    </div>
  );
}

export default EmptyState;
